import React, { useState } from 'react';
import { CITY_SUGGESTIONS } from './homeSearch';

// Pick several cities/areas as chips. Saved as one comma-separated string ("Naples, Estero"), the same
// format older records and the AI connector's `areas` field already use, so nothing else has to change.
export const splitAreas = (v) => (Array.isArray(v) ? v : String(v || '').split(/[,;]/)).map((x) => String(x).trim()).filter(Boolean);

export default function CityMultiSelect({ value, onChange, inputStyle }) {
  const list = splitAreas(value);
  const [custom, setCustom] = useState('');
  const emit = (next) => onChange([...new Set(next)].join(', '));
  const addOne = (c) => { const v = String(c || '').trim(); if (v && !list.some((x) => x.toLowerCase() === v.toLowerCase())) emit([...list, v]); };
  const chip = { display: 'inline-flex', alignItems: 'center', gap: 4, padding: '4px 10px', borderRadius: 14, background: '#FBF7EC', border: '1px solid #B8962E', fontSize: 13 };
  return (
    <div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: list.length ? 6 : 0 }}>
        {list.map((c) => (
          <span key={c} style={chip}>{c}<button type="button" aria-label={`Remove ${c}`} onClick={() => emit(list.filter((x) => x !== c))} style={{ border: 'none', background: 'none', cursor: 'pointer', fontWeight: 700, padding: 0 }}>x</button></span>
        ))}
      </div>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        <select style={{ ...inputStyle, flex: '1 1 140px', width: 'auto' }} value="" onChange={(e) => addOne(e.target.value)} aria-label="Add a city">
          <option value="">Add a city...</option>
          {CITY_SUGGESTIONS.filter((c) => !list.includes(c)).map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
        <input style={{ ...inputStyle, flex: '1 1 140px', width: 'auto' }} placeholder="Other city or community" value={custom} onChange={(e) => setCustom(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); addOne(custom); setCustom(''); } }} />
        <button type="button" onClick={() => { addOne(custom); setCustom(''); }} disabled={!custom.trim()} style={{ padding: '6px 12px', borderRadius: 4, border: '1px solid #B8962E', background: '#fff', cursor: 'pointer' }}>Add</button>
      </div>
    </div>
  );
}
